import KuestionMark from '../kuestion/KuestionMark';
import { kq } from '../../config/routes';
import './ApplicationsMenu.css';

// Every application that has guides. The section label counts this list, so
// a second app is one row here and nothing else changes.
const KB_APPS = [
  { key: 'kuestion', name: 'Kuestion', href: kq('kb'), mark: <KuestionMark bodyFill="currentColor" leafFill="currentColor" glyphFill="var(--color-accent)" /> },
];

const ExternalIcon = ({ size = 11, width = 2.6, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={width} strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M14 4h6v6" /><line x1="20" y1="4" x2="11" y2="13" /><path d="M18 14.5V19a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 19V7.5A1.5 1.5 0 0 1 5 6h4.5" />
  </svg>
);

/**
 * The Knowledge base entry in the site navbar (design note "KB entry points
 * and routing", 19 Sep 2026). On the landing page the visitor does not yet
 * know which product's guides they want, so it is a picker shaped like the
 * Applications menu beside it. On the Kuestion product page they do, so it is
 * a plain link. Either way the KB opens in a new tab: the page the visitor
 * was on should still be there when they come back.
 *
 * Open state is owned by the navbar, so this menu and Applications are
 * mutually exclusive.
 */
export default function KnowledgeBaseMenu({ mode = 'menu', open = false, onToggle, onClose, menuRef }) {
  if (mode === 'link') {
    return (
      <a className="rw-nav__item" href={kq('kb')} target="_blank" rel="noopener noreferrer" title="Knowledge base — opens in a new tab">
        Knowledge base
        <ExternalIcon />
      </a>
    );
  }

  return (
    <div className="rw-apps" ref={menuRef}>
      <button type="button" className="rw-nav__item" aria-expanded={open} aria-haspopup="true" onClick={onToggle}>
        Knowledge base
        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>

      {open && (
        <div className="rw-apps__menu">
          <div className="rw-apps__count">Guides for {KB_APPS.length} {KB_APPS.length === 1 ? 'application' : 'applications'}</div>
          {KB_APPS.map((app) => (
            <a key={app.key} className="rw-apps__item" href={app.href} target="_blank" rel="noopener noreferrer" onClick={onClose}>
              <span className="rw-apps__tile">{app.mark}</span>
              <span style={{ flex: 1, minWidth: 0 }}>
                <span className="rw-apps__name">{app.name}</span>
                <span className="rw-apps__desc">User guides &middot; opens in a new tab</span>
              </span>
              <ExternalIcon size={14} width={2.4} className="rw-apps__ext" />
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
